<template>
  <div class="resonance-viz">
    
    <div class="viz-header" >
      <div class="brief" v-latex="knowledgePoint"></div>
      <div class="formula" v-latex>$<strong>公式：</strong>f_drive ≈ f_natural$</div>
    </div>

    <div class="main-layout vertical">
      <!-- 渲染区：振幅-频率曲线 -->
      <div class="canvas-mixed simulation">
         <svg width="100%" height="220" viewBox="0 0 400 220">
            <!-- 坐标轴 -->
            <line x1="50" y1="180" x2="350" y2="180" stroke="#888" />
            <line x1="50" y1="180" x2="50" y2="30" stroke="#888" />
            <text x="360" y="185" fill="#888" font-size="9">驱动频率 f</text>
            <text x="45" y="25" fill="#888" font-size="9">振幅 A</text>

            <!-- 共振曲线 -->
            <path :d="resonanceCurve" fill="none" stroke="#00d2ff" stroke-width="2.5" />
            
            <!-- 物理实体 (弹簧振子) -->
            <g transform="translate(300, 80)">
               <path :d="springPath" fill="none" stroke="#888" stroke-width="2" />
               <circle cx="0" :cy="oscillationY" r="10" fill="#ff4757" />
               <text x="-30" y="-40" fill="#fff" font-size="10">受迫物体</text>
            </g>

            <!-- 工作点指标 -->
            <circle :cx="50 + driveFreq * 30" :cy="180 - currentAmp * 10" r="4" fill="#ffd700" />
         </svg>

         <div class="hud-top">
            <div class="stat">
               <label>固有频率</label>
               <span class="val">{{ naturalFreq }} Hz</span>
            </div>
            <div class="stat">
               <label>当前振幅</label>
               <span class="val">{{ currentAmp.toFixed(1) }}</span>
            </div>
         </div>
      </div>

      <!-- 参数控制 -->
      <div class="bottom-controls">
         <div class="control-card glass">
            <div class="row">
               <label>驱动力频率 f_drive (Hz)</label>
               <el-slider v-model="driveFreq" :min="1" :max="10" :step="0.1" size="mini"></el-slider>
            </div>
         </div>

         <div class="law-box">
            <p><strong>物理详解：</strong>物体在驱动力作用下的振动称为<strong>受迫振动</strong>。当驱动频率接近物体的<strong>固有频率</strong>时，振幅达到最大，这种现象称为<strong>共振</strong>。其在桥梁设计、乐器发声等领域有广泛应用。</p>
         </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ResonanceViz',
  props: { knowledgePoint: { type: String, default: '' } },
  data() {
    return {
      driveFreq: 2,
      naturalFreq: 5,
      t: 0,
      running: true
    }
  },
  computed: {
    currentAmp() {
       // Lorentzian resonance curve approximation
       const diff = this.driveFreq - this.naturalFreq;
       const gamma = 1; // damping
       return 15 / (diff * diff + gamma);
    },
    oscillationY() {
       return Math.sin(this.t * this.driveFreq) * (this.currentAmp * 2);
    },
    resonanceCurve() {
       let d = "M 50 180";
       for(let f=0; f<=10; f+=0.2) {
          const diff = f - this.naturalFreq;
          const amp = 15 / (diff * diff + 1);
          const y = 180 - amp * 10;
          d += ` L ${50 + f * 30} ${y}`;
       }
       return d;
    },
    springPath() {
       let d = "M 0 -30";
       const segments = 10;
       const h = 30 + this.oscillationY;
       for(let i=1; i<=segments; i++) {
          const y = -30 + (h/segments) * i;
          const x = (i % 2 === 0) ? 5 : -5;
          d += ` L ${x} ${y}`;
       }
       return d;
    }
  },
  mounted() { this.animate(); },
  beforeDestroy() { this.running = false; },
  methods: {
    animate() {
       if (!this.running) return;
       this.t += 0.2;
       requestAnimationFrame(this.animate);
    }
  }
}
</script>

<style scoped lang="scss">
.resonance-viz { flex: 1; display: flex; flex-direction: column; gap: 12px; height: 100%; overflow: hidden; }
.viz-header { display: flex; justify-content: space-between; align-items: center; .title { font-size: 1rem; color: #fff; } .formula-chip { color: #00d2ff; background: rgba(0,210,255,0.1); padding: 4px 12px; border-radius: 8px; font-weight: bold; } }
.canvas-mixed { 
   background: #000; border-radius: 12px; position: relative; border: 1px solid rgba(255,255,255,0.05);
   .hud-top { position: absolute; top: 15px; left: 15px; display: flex; gap: 20px;
      .stat { background: rgba(0,0,0,0.6); padding: 5px 12px; border-radius: 6px; border-left: 3px solid #00d2ff; label { display: block; font-size: 0.55rem; color: #888; } span { font-size: 0.9rem; color: #fff; font-family: monospace; } }
   }
}
.bottom-controls { flex: 0.5; display: flex; flex-direction: column; gap: 10px; }
.control-card { background: rgba(255,255,255,0.03); border-radius: 12px; padding: 15px; label { font-size: 0.7rem; color: #888; display: block; margin-bottom: 5px; } }
.law-box { background: rgba(0, 210, 255, 0.05); padding: 12px 18px; border-radius: 12px; p { margin: 0; font-size: 0.75rem; color: #aaa; line-height: 1.5; strong { color: #fff; } } }
</style>
